import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../components/DataNotFound';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import SearchFilters from '../../../../components/elements/SearchFilter';
import Userbanner from '../../../../components/elements/Userbanner';
import { getFromLocalStorage } from '../../../../components/helper/authorizationHelper';
import { postAsync } from '../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../components/helper/downloadCSVHelper';
import { Link } from 'react-router-dom';
import { PageHitCountApi } from '../../../../shared/Helper';
import { useLocation } from 'react-use';
import { printTable } from '../../../../utils/tableExportUtils';

const Idea_Sugg_UP_RegistrationList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [epUserID, setEpUserID] = useState(null);
  const [isLoad, setIsLoad] = useState(false);
  const [next, setNext] = useState(1);
  const [searchTitle, setSearchTitle] = useState('');

  const [datanotfound, setDatanotfound] = useState(false);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const token = localStorage.getItem('token');

  const isLogin = () => {
    if (!token && !epUserID) {
      navigate('/donorLogin');
    }
  };

  const bodyGet = {
    EPUserID: epUserID,
  };

  const getData = async () => {
    try {
      setIsLoad(true);
      await postAsync(
        'EPIdeaService/EPIdeaServiceFilterListById/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
        bodyGet,
      ).then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }

        if (response?.data && response?.data.length > 0) {
          setPageCount(response?.page);
        }
      });
    } catch (err) {
      console.error(err);
      toast.error(`${t('msg_errorDueto')}: ${err.message}`);
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    isLogin();
    if (epUserID !== null) {
      getData();
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);

  const SearchFilter = {
    epUserID: epUserID,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    title: searchTitle,
  };

  const getPaginationList = async () => {
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(
      'EPIdeaService/EPIdeaServiceFilterListById/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
      SearchFilter,
    )
      .then((response) => {
        setIsLoad(false);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
        setApiData(response?.data);
        apiData?.map((data) => {
          setPageCount(data?.page);
        });
      })
      .catch((err) => {
        console.log(err);
        toast.error(`${t('msg_errorDueto')}` + ':' + err.message);
      });
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;

    await postAsync('EPIdeaService/EPIdeaServiceFilterListById/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(`${t('msg_errorDueto')}` + ':' + err.message);
      });
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    await getPaginationList();
  };

  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      [t('S.No')]: ii + 1,
      [t('Title')]: isActive ? item.titleAr : item.titleEn,
      [t('Description')]: isActive ? item.descAr : item.descEn,
      [t('Date')]: item.date,
      [t('Time')]: item.timeNow,
    }));
    downloadCSV(filteredData, 'Idea Suggestion Registration List');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   // Create a temporary container
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Idea Suggestion')} ${t('list')}`;
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Title`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Description`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Time`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.titleEn || 'N/A' : data?.titleEn || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.descEn || 'N/A' : data?.descEn || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.date || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.timeNow}</td>
  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
  const handlePrint = (e) => {
    e.preventDefault();

    // Column configuration
    const columns = [
      {
        header: t('sNo'),
        accessor: (row, index) => index + 1,
      },
      {
        header: t('Title'),
        accessor: (row) => (isActive ? row?.titleEn || 'N/A' : row?.titleEn || 'N/A'),
      },
      ,
      {
        header: t('Description'),
        accessor: (row) => (isActive ? row?.descEn || 'N/A' : row?.descEn || 'N/A'),
      },

      {
        header: t('Date'),
        accessor: (row) => row?.date || 'N/A',
      },
      {
        header: t('Time'),
        accessor: (row) => row?.timeNow || 'N/A',
      },
    ];

    // Call the reusable print function
    printTable({
      data: apiData || [],
      isRTL: isActive, // isActive true = Arabic = RTL
      t: t,
      title: `${t('Idea Suggestion')} ${t('list')}`,
      columns: columns,
      onBeforePrint: () => {
        console.log('Printing started...');
        // toast.info(t('Preparing print preview...'));
      },
      onAfterPrint: () => {
        console.log('Printing completed');
      },
      styles: {
        customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `,
      },
    });
  };
  const handleRoute = (id) => {
    const link = '/IdeaSuggUpView/';
    navigate(link, { state: { id: id } });
  };

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;
    return (
      <Table.Row key={index} items={apiData}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{isActive ? data?.titleEn || 'N/A' : data?.titleEn || 'N/A'}</Table.Cell>
        <Table.Cell>{isActive ? data?.descEn || 'N/A' : data?.descEn || 'N/A'}</Table.Cell>
        <Table.Cell>{data?.date}</Table.Cell>
        <Table.Cell>{data?.timeNow}</Table.Cell>
        <Table.Cell>
          <button
            onClick={() => handleRoute(data?.ideaServiceID)}
            className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
          >
            {t('')} <VisibilityOutlinedIcon />
          </button>
        </Table.Cell>
      </Table.Row>
    );
  });

  return (
    <div className="py-5 lg:py-10">
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
          <Userbanner />

          <div className="container-fluid">
            {/* pending but working  */}
            <div className="row text-center justify-center">
              <div className="col-lg-11 ">
                <div className="flex justify-end   my-4">
                  <Link className="items-center md:items-end" to="/EPUserIdeaSuggestion">
                    <button className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center">
                      {t('create')}
                    </button>
                  </Link>
                </div>
              </div>
            </div>

            <div className="row justify-center">
              <SearchFilters
                handleSearch={handleSearch}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'Idea Suggestion'}
                isTitleVisible={true}
                setSearchTitle={setSearchTitle}
                isApplicantName={false}
              />

              <div className="col-lg-11 pt-9">
                {isLoad ? (
                  <LoadingAnimation
                    imageStyling={''}
                    styling={'flex items-center py-5 align-middle justify-center space-x-2'}
                  />
                ) : (
                  <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <Table className="text-sm tableData text-left rtl:text-right ">
                      <Table.Header className="text-sm font-bold text-white bg-customgreen uppercase  ">
                        <Table.Row>
                          <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Title')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Description')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Date')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Time')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                          {!setLoader && <Table.HeaderCell className="text-white">{t('')}</Table.HeaderCell>}
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>{displayRecords}</Table.Body>

                      <Table.Footer className="page-items"></Table.Footer>
                    </Table>
                    {datanotfound && <DataNotFound />}
                  </div>
                )}
                {pageCount > 0 && (
                  <div className="flex flex-row px-12 justify-between">
                    <Menu floated="right" pagination>
                      <Menu.Item>
                        <ReactPaginate
                          previousLabel={t('Previous')}
                          nextLabel={t('Next')}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={'paginationButtons'}
                          previousLinkClassName={'previousButton'}
                          nextLinkClassName={'nextButton'}
                          disabledClassName={'paginationDisabled'}
                          activeClassName={'paginationActive'}
                        />
                      </Menu.Item>
                    </Menu>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Idea_Sugg_UP_RegistrationList;
